import React, { Fragment, PureComponent } from "react";
import axios from "axios";
import { server, config, checkAccess } from "../../env";
import Header from "../../components/Header";
import Alert from "../../components/Alert";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal";
import { Link } from "react-router-dom";
import TopCard from "../DashboardComponents/StatsTopCard";

export default class PremiumResidential extends PureComponent {
  state = {
    loader: "",
    message: "",
    copyButton: "Copy",
    proxies: [],
    data: [],

    have_plan: false,
    plan_data: [],
    user_data: [],
    usage_stats: [],
    planType: "normal",
    isPendingPlan: false,

    ips: [],
    ipMessage: "",

    countries: [],
    countryCode: "",
    cities: [],
    isps: [],
  };

  componentDidMount = () => {
    document.title = "Premium Residential Proxies - Proxies.gg";
    this.readDataStats();
    this.readCountries();
  };

  readDataStats = async () => {
    await axios
      .get(server + "/v1/user/dashboard", config)
      .then((rsp) => {
        this.setState({
          have_plan: rsp.data.payload.PR_6.have_plan,
          plan_data: rsp.data.payload.PR_6.plan_data,
          allPlans: rsp.data.payload.PR_6.plan_data,
          user_data: rsp.data.payload.PR_6.user_data,
          usage_stats: rsp.data.payload.PR_6.usage_stats,
          isPendingPlan: rsp.data.payload.PR_6.isPendingPlan,
        });
      })
      .catch((err) => {
        checkAccess(err);
      });
  };

  readCountries = () => {
    axios
      .get(`${server}/v1/user/get-country-stats`, config)
      .then((res) => {
        this.setState({
          countries: res.data.payload.countries.countries,
          countryCode: "all",
          cities: [],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  copyCodeToClipboard = () => {
    const el = this.textArea;
    el.select();
    document.execCommand("copy");
    this.setState({ copyButton: "Copied" });
  };

  generateProxies = async (e) => {
    e.preventDefault();
    this.setState({
      loader: <Loader />,
      message: "",
    });

    const params = {
      proxy_type: "PR_6",
      ptype: e.target.ptype.value,
      country: this.state.countryCode,
      city: e.target.city.value,
      isp: e.target.isp.value,
      amount: e.target.amount.value,
      type: e.target.type.value,
    };

    await axios
      .post(server + "/v1/user/generate-proxy", params, config)
      .then(async (rsp) => {
        await this.setState({
          data: rsp.data.payload,
        });
        this.setState({
          proxies: rsp.data.payload.proxies,
          message: (
            <Alert className="success" message="Your proxies are here." />
          ),
          loader: "",
        });
      })
      .catch((err) => {
        checkAccess(err);
        if (err.response) {
          this.setState({
            message: (
              <Alert className="danger" message={err.response.data.detail} />
            ),
          });
        }
        this.setState({
          loader: false,
        });
      });
  };

  activatePlan = (e) => {
    e.preventDefault();

    this.setState({
      loader: <Loader />,
    });

    const params = {
      ips: [e.target.ips.value],
    };

    axios
      .post(server + "/v1/user/activate-plan", params, config)
      .then((rsp) => {
        this.setState({
          loader: "",
          ipMessage: <Alert message={rsp.data.detail} className="success" />,
        });
        this.readDataStats();
      })
      .catch((err) => {
        console.log(err);
        checkAccess(err);
        if (err.response) {
          this.setState({
            loader: "",
            ipMessage: (
              <Alert message={err.response.data.detail} className="danger" />
            ),
          });
        }
      });
  };

  onChangeLocation = (e) => {
    this.setState({
      countryCode: e.target.value,
      cities: this.state.countries.filter(
        (country) => country.code === e.target.value
      )[0].cities.options,
    });
  };

  onChangeCity = (e) => {
    this.setState({
      city: e.target.value,
      isps: this.state.cities.find((city) => city.code === e.target.value).isps
        .options,
    });
  };

  render() {
    const { proxies, loader, copyButton, message, ipMessage } = this.state;
    const { have_plan, plan_data, user_data } = this.state;
    const { isPendingPlan, countries, cities, isps } = this.state;

    return (
      <Fragment>
        <div className="main-content">
          <Header pretitle="Dashboard" title="Premium Residential Proxies" />
          <div className="container-fluid">
            <div className="row justify-content-between">
              <div className="col-auto"></div>
              <div className="col-auto">
                {/* <div
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#whitelistIP"
                  onClick={() =>
                    this.setState({
                      message: "",
                    })
                  }
                >
                  Whitelist IPs
                </div> */}
              </div>
            </div>
            {user_data ? (
              <Fragment>
                {isPendingPlan ? (
                  <div
                    className="alert alert-primary alert-dismissible fade show"
                    role="alert"
                  >
                    <strong>Activate Plan!</strong> Your account having a plan
                    to activate click here to{" "}
                    <Link
                      to="#"
                      className="text-white text-decoration-underline"
                      data-bs-toggle="modal"
                      data-bs-target="#activatePlan"
                      onClick={() =>
                        this.setState({
                          message: "",
                        })
                      }
                    >
                      Activate
                    </Link>
                  </div>
                ) : (
                  ""
                )}
                <div className="row">
                  <TopCard
                    title="Active Plan"
                    value={have_plan ? plan_data.invoice.plan_name : "N/A"}
                    icon="fe-box"
                  />
                  <TopCard
                    title="Data Left"
                    value={
                      have_plan
                        ? user_data?.data?.availableTraffic?.toFixed(2) + " GB"
                        : "0 GB"
                    }
                    icon="fe-hard-drive"
                  />
                  <TopCard
                    title="Used Data"
                    value={
                      have_plan
                        ? user_data?.data?.usedTraffic?.toFixed(2) + " GB"
                        : "0 GB"
                    }
                    icon="fe-calendar"
                  />
                </div>

                {/* Activate Plan */}
                <Modal id="activatePlan" title="Activate Plan">
                  <div className="modal-body">
                    <form onSubmit={this.activatePlan}>
                      {ipMessage}
                      <div className="form-group">
                        <label htmlFor="">Whitelist IP</label>
                        <input
                          type="text"
                          name="ips"
                          id="ips"
                          className="form-control"
                        />
                      </div>
                      <div className="form-group text-end">
                        <button type="submit" className="btn btn-primary">
                          Activate {loader}
                        </button>
                      </div>
                    </form>
                  </div>
                </Modal>

                {/* Whitelist IP */}
                <Modal id="whitelistIP" title="Whitelist IP">
                  <div className="modal-body">
                    <form onSubmit={this.whitelistIP}>
                      {ipMessage}
                      <div className="form-group">
                        <label htmlFor="">Whitelist IP</label>
                        <input
                          type="text"
                          name="ips"
                          id="ips"
                          className="form-control"
                        />
                      </div>
                      <div className="form-group text-end">
                        <button type="submit" className="btn btn-primary">
                          Whitelist IP {loader}
                        </button>
                      </div>
                    </form>
                  </div>
                </Modal>
              </Fragment>
            ) : (
              ""
            )}
            <div className="row">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-header-title">Generate Proxies</h4>
                  </div>
                  <div className="card-body">
                    <small className="text-muted">
                      Select a Country For Country-Specific Proxies Or Select
                      Worldwide For All Countries Mixed
                    </small>
                    <form className="mt-4" onSubmit={this.generateProxies}>
                      <div className="form-group">
                        <label>Choose Location</label>
                        <select
                          name="location"
                          id="location"
                          className="form-control"
                          onChange={this.onChangeLocation}
                        >
                          <option value="all">Worldwide</option>
                          {countries.map((country) => (
                            <option key={country.code} value={country.code}>
                              {country.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>Choose City</label>
                        <select
                          name="city"
                          id="city"
                          className="form-control"
                          onChange={this.onChangeCity}
                        >
                          <option value="all">All Cities</option>
                          {cities.map((city) => (
                            <option key={city.code} value={city.code}>
                              {city.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>Choose ISP</label>
                        <select name="isp" id="isp" className="form-control">
                          <option value="all">All ISPs</option>
                          {isps.map((isp) => (
                            <option key={isp.code} value={isp.code}>
                              {isp.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="choose_location">Proxy Type</label>
                        <select
                          name="ptype"
                          className="form-control"
                          id="ptype"
                          required
                        >
                          <option value="http">HTTP/S</option>
                          <option value="sock">SOCKS5</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="choose_location">Choose Type</label>
                        <select
                          name="type"
                          className="form-control"
                          id="type"
                          required
                        >
                          <option value="random">Rotating</option>
                          <option value="sticky">Sticky</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="choose_location">
                          Quantity (1-10000)
                        </label>
                        <input
                          type="number"
                          name="amount"
                          id="amount"
                          min="1"
                          max="10000"
                          defaultValue="1"
                          className="form-control"
                          required
                        />
                      </div>
                      <div className="form-group float-right mb-n1">
                        <button type="submit" className="btn btn-primary w-100">
                          Generate{loader}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-header-title">Your proxies are here</h4>
                  </div>
                  <div className="card-body">
                    {message}
                    <div className="form-group">
                      <textarea
                        name="proxies"
                        id="proxies"
                        cols="30"
                        rows="10"
                        className="form-control"
                        value={proxies.toString().split(",").join("\n")}
                        ref={(textarea) => (this.textArea = textarea)}
                      ></textarea>
                    </div>
                    <div className="form-group">
                      <button
                        onClick={this.copyCodeToClipboard}
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        id="alertify-success"
                      >
                        {copyButton}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
